/**
 * 系统管理模块
 */

export default [
  {
    name: 'admin',
    path: '/admin',
    redirect: '/admin/user',
    noLevel: true,
    meta: {
      title: '角色用户管理',
      href: '/admin'
    },
    component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin'),
    children: [
      {
        name: 'user',
        path: 'user',
        meta: {
          title: '用户管理',
          href: '/user'
        },
        component: () => import(/* webpackChunkName: 'user' */ '@/views/admin/user')
      },
      {
        name: 'role',
        path: 'role',
        meta: {
          title: '角色管理',
          href: '/role'
        },
        component: () => import(/* webpackChunkName: 'role' */ '@/views/admin/role')
      },
    ]
  }];
